import { useMemo } from 'react';
import { useAuthStore } from '@/stores';

// Decode the `role` claim from a JWT access token. The backend's source of truth
// for super_admin is the JWT (role: 'super_admin' | 'user'), NOT the frontend
// user.role (which carries a separate legacy DB role like 'admin').
function decodeTokenRole(token: string): string | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = JSON.parse(atob(padded));
    return typeof json?.role === 'string' ? json.role : null;
  } catch {
    return null;
  }
}

export function useIsSuperAdmin(): boolean {
  const accessToken = useAuthStore((s) => s.accessToken);
  return useMemo(() => decodeTokenRole(accessToken) === 'super_admin', [accessToken]);
}
